import { vatRateOptions } from '@/constants'
import { SharedProps } from '@/types'
import { useForm, usePage } from '@inertiajs/react'
import { Autocomplete, Button, Group, NumberInput, Select, Stack, TextInput } from '@mantine/core'

export default function ArticleServiceForm({
  initialData,
  action,
}: {
  initialData: {
    id?: number
    article_name: string
    service_name: string
    price: number
    contract_price: number | string
    vat_rate: number | string
  }
  action: 'new' | 'edit'
}) {
  const { props } = usePage<SharedProps>()
  const current_organization = props.current_organization
  const { data, setData, post, patch, processing } = useForm({ article_service: initialData })

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    const url = `/organizations/${current_organization?.slug}/article_services`
    action === 'new' ? post(url) : patch(`${url}/${initialData.id!}`)
  }

  const handleVatRateChange = (value: string | null) => value && setData('article_service.vat_rate', value)


  const submitLabel = action === 'new' ? 'Créer le service' : 'Enregistrer les modifications'
  const articleNames = props.article_names as string[]

  return (
    <form onSubmit={handleSubmit}>
      <Stack gap="md">
        <Autocomplete
          label="Nom de l'article"
          placeholder="Ex: Pantalon, Veste..."
          required
          data={articleNames}
          value={data.article_service.article_name}
          onChange={(value: string) => setData('article_service.article_name', value)}
        />
        <TextInput
          label="Service"
          placeholder="Ex: Ourlet, Retouche taille..."
          required
          value={data.article_service.service_name}
          onChange={(event) => setData('article_service.service_name', event.target.value)}
        />
        <NumberInput
          label="Prix"
          placeholder="0.00"
          required
          decimalScale={2}
          fixedDecimalScale
          value={data.article_service.price}
          onChange={(value) => setData('article_service.price', Number(value))}
        />
        <NumberInput
          label="Prix contrat (sociétés, HT)"
          description="Prix hors taxes des commandes sous contrat. Laissez vide pour utiliser le prix ci-dessus."
          placeholder="Identique au prix"
          decimalScale={2}
          fixedDecimalScale
          min={0}
          value={data.article_service.contract_price}
          onChange={(value) => setData('article_service.contract_price', value)}
        />
        <Select
          label="TVA"
          data={vatRateOptions}
          value={String(Number(data.article_service.vat_rate))}
          onChange={handleVatRateChange}
          allowDeselect={false}
        />
        <Group justify="flex-end" mt="xl">
          <Button type="submit" loading={processing}>
            {submitLabel}
          </Button>
        </Group>
      </Stack>
    </form>
  )
}
